<template>
  <a-modal
    v-if="workExperience"
    :visible="visible"
    title="Are you sure you want to delete this work experience?"
    ok-text="Yes"
    ok-type="danger"
    cancel-text="No"
    @ok="() => handleDeleteWorkExperience(workExperience.id)"
    @cancel="$emit('close')"
  >
  </a-modal>
</template>

<script setup lang="ts">
import { WorkExperienceInterface } from "../types";

// Props
const props = defineProps({
  visible: { type: Boolean, default: false },
  workExperience: { type: Object as () => WorkExperienceInterface, default: undefined },
});

// Emits
const emits = defineEmits(["delete-work-experience", "close"]);

// Class methods
const handleDeleteWorkExperience = (workExperienceId: number): void => {
  emits("delete-work-experience", workExperienceId);
  emits("close");
};
</script>
